import { render, staticRenderFns } from "./DocumentOcrPages.vue?vue&type=template&id=1c650f50&scoped=true&"
import script from "./DocumentOcrPages.vue?vue&type=script&lang=js&"
export * from "./DocumentOcrPages.vue?vue&type=script&lang=js&"
import style0 from "./DocumentOcrPages.vue?vue&type=style&index=0&id=1c650f50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c650f50",
  null
  
)

export default component.exports